import { useStore, useStoreMap, useGate } from 'effector-react'
import { Form, employeeModel } from '~/entities/common/Taxipark/Employee'
import { usePermissions } from '~/entities/common/viewer'
import { localeEnumLabels, timezoneCodeLabels } from '~/shared/config/constants'
import { formSubmitted, Gate, $employee, employeeUpdateFx } from './model'

type EditEmployeeProps = {
  employeeId: string
}

export function EditEmployee({ employeeId }: EditEmployeeProps) {
  useGate(Gate, { employeeId })
  const { canUsersUpdate } = usePermissions()

  const isLoading = useStore(employeeModel.requestFx.pending)
  const isSaving = useStore(employeeUpdateFx.pending)

  const defaultValues = useStoreMap($employee, (employee) => {
    const timezone = employee?.getTimezone()
    const locale = employee?.getLocale()
    return {
      ...employee?.getAttributes(),
      rolesIds: employee?.getRoles()?.map((role) => role.getOption()),
      regionsIds: employee?.getRegions()?.map((region) => region.getOption()),
      carRentalsIds: employee
        ?.getCarRentals()
        ?.map((region) => region.getOption()),
      timezone: timezone
        ? {
            id: timezone,
            label: timezoneCodeLabels[timezone],
          }
        : null,
      locale: locale
        ? {
            id: locale,
            label: localeEnumLabels[locale],
          }
        : null,
    }
  })

  return (
    <Form
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canUsersUpdate}
    />
  )
}
